import Breadcrumb from './Breadcrumb';
import BreadcrumbItem from './BreadcrumbItem';
import BreadcrumbSeparator from './BreadcrumbSeparator';
Breadcrumb.Item = BreadcrumbItem;
Breadcrumb.Separator = BreadcrumbSeparator;
export default Breadcrumb;


//////////////////
// WEBPACK FOOTER
// ../~/antd/es/breadcrumb/index.js
// module id = 309
// module chunks = 0